// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ActivityStatusResults_abstract } from './../../abstract/SagaBase/Defines/ActivityStatusResults_abstract';
export class ActivityStatusResults extends ActivityStatusResults_abstract {}
